import React from 'react';

import { REFERRAL_ANNUAL } from '../../../utils/backend-api/subscribe';
import { CustomToaster } from '../../BaseUI';
import SubscriptionForm from '../../SubscriptionForm';
import PlanOptions from './PlanOptions';

interface ReferralSubscription {
  referringSubName: string;
  referringSubGuid: string;
  currentTrialEndDate: string;
  userFullName?: string;
  userEmail?: string;
  stripeCustomerId?: string;
}

const Subscription = ({
  referringSubName,
  referringSubGuid,
  currentTrialEndDate,
  userFullName,
  userEmail,
  stripeCustomerId,
}: ReferralSubscription) => {
  return (
    <>
      <CustomToaster />
      <PlanOptions referringSubName={referringSubName} />
      <div className="tw-w-full sm:tw-w-8/12 lg:tw-w-6/12 tw-mx-auto tw-px-12">
        <SubscriptionForm
          buttonText="Start 14-Day Free Trial"
          selectedOffer={REFERRAL_ANNUAL}
          referringSubscriberGuid={referringSubGuid}
          referringSubscriberName={referringSubName}
          currentTrialEndDate={currentTrialEndDate}
          userFullName={userFullName}
          userEmail={userEmail}
          stripeCustomerId={stripeCustomerId}
        />
      </div>
    </>
  );
};

export default Subscription;
